<template>
  <v-container>
    <p>New cleaning supply</p>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="cleaning_supply.name"
              label="Name"
              :rules="[rules.require]"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="cleaning_supply.price"
              label="Price"
              :rules="[rules.require]"
              type="number"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <app-supplier-list
          :supplier_list="supplier_list"
        />
        <v-divider></v-divider>
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            color="orange"
            dark
            @click="createCleaningSupply"
          >
            Create
          </v-btn>
          <v-btn
            class="mx-2"
            small
            exact
            :to="{ name: 'cleaning-supply-list' }"
          >
            Cancel
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: "CleaningSupplyCreate",
  components: {
    AppSupplierList: () => import('../components/supplier-list')
  },
  data: () => ({
    cleaning_supply: {
      name: null,
      price: null
    },
    supplier_list: [],
    rules: {
      require: value => !!value || 'Please fill in information',
    },
  }),
  methods: {
    async createCleaningSupply () {
      try {
        if (this.requireField()) {
          const { data } = await this.$http.post('/back-office/cleaning-supplies', this.cleaning_supply, authHeader())
          let cleaning_supply_id = data.id
          let suppliers = []
          for (let supplier of this.supplier_list) {
            if (supplier.selected)
              suppliers.push(supplier.id)
          }
          await this.$http.put(`/back-office/cleaning-supplies/${cleaning_supply_id}/suppliers`, { suppliers }, authHeader())
          this.$router.push({ name: 'cleaning-supply-list'})
        }
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    requireField () {
      if (!this.cleaning_supply.name) {
        alert('Please fill in cleaning supply name')
        return false
      }
      if (!this.cleaning_supply.price) {
        alert('Please fill in cleaning supply price')
        return false
      }
      return true
    },
  },
};
</script>
